const getMatchingKey = (data1, data2) => {
    return Object.keys(data1).find((key) => data2[key])
}

export {getMatchingKey}